// extracted by mini-css-extract-plugin
export default {"title":"_199y1","separator":"_2LaOF","paragraph":"_2mB7W","button":"_3jobV","rightButton":"_2DcHu _3jobV"};